
import { css } from 'lit';
export default css`
.search-panel-result {
  display: flex;
  height: 100%;
  flex-direction: column;
}

  .search-panel-result--default .search-panel-result__heading {
      margin-bottom: 5px;
    }

  @media (min-width: 1024px) {

  .search-panel-result--default .search-panel-result__heading {
        min-height: 55px
    }
      }

  .search-panel-result--full-search .search-panel-result__see-all {
  margin-top: 1.25rem;
}

  .search-panel-result__results {
  margin-bottom: 0.5rem;
}

  .search-panel-result__heading {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}

  .search-panel-result__see-all {
  margin-top: auto;
}

  .search-panel-result__see-all {
  display: flex;
}

  .search-panel-result__see-all {
  align-items: center;
}

  .search-panel-result__see-all {
  font-weight: 700;
}

  .search-panel-result__see-all {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .search-panel-result__see-all {
    font-size: 18px;
    line-height: 27px;
  }

  .search-panel-result__see-all .search__panel__item-icon {
  margin-left: 0.75rem;
}

  .search-panel-result__see-all .search__panel__item-icon {
  height: 1rem;
}

  .search-panel-result__see-all .search__panel__item-icon {
  width: 1rem;
}

  .search-panel-result__see-all:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

  .search-panel-result__see-all:hover {
  text-decoration: underline;
}

  .search-panel-result--main-menu-search {
  flex-direction: row;
}

  .search-panel-result--main-menu-search {
  flex-wrap: wrap;
}

  .search-panel-result--main-menu-search {
  align-items: baseline;
}

  @media (min-width: 1024px) {

  .search-panel-result--main-menu-search .search-panel-result__heading {
    width: 100%;
  }
}

  @media (min-width: 1024px) {

  .search-panel-result--main-menu-search .search-panel-result__results {
    width: 50%;
  }
}

  @media (min-width: 1024px) {

  .search-panel-result--main-menu-search .search-panel-result__see-all {
    width: 50%;
  }
}
`;